













import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component
class LoginRequiredField extends Vue {
  @Getter("auth/isLogged") isLogged;

  handleLogin() {
    this.$common.utils.helper.requestLogin(this);
  }
}
export default LoginRequiredField;
